import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Calls the API to retrieve functional usage whenever a load request is
 * dispatched.
 */
export const executeLoad = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.load.request.observe().pipe(
      rxjs.switchMap(action => {
        const { clusterId, context } = action.data

        return plugin.api.get({ ...context, clusterId }).pipe(
          rxjs.takeUntil(
            rxjs.merge(
              plugin.collection.feature.actions.changeContext.observe(),
              feature.actions.loadForCurrentEntity.request.observe(),
            ),
          ),
          rxjs.map(response =>
            feature.actions.load.success
              .from(action)
              .create({ request: action.data, response }),
          ),
          rxjs.catchError((error: Error) =>
            rxjs.of(
              feature.actions.load.error
                .from(action)
                .create({ error, request: action.data }),
            ),
          ),
        )
      }),
    ),
)
